<template>
  <div class="max-w-3xl m-auto my-8">
    <p class="text-sm uppercase text-left text-gray-500">
      {{
        `Add a sending domain you wish to validate. A few simple DNS configurations are required in order for your emails to be sent directly from your custom domains.`
      }}
    </p>
  </div>
</template>
